'use client'

import KeywordChip from '@/components/KeywordChip'
import { Ai_agent, Filter, Question, Quote, Search, Search_as_you_type, Search_or_ask, Spark } from '@indxsearch/pixl'
import ConsoleFeature, { chipClass } from './ConsoleFeature'

// Search or ask as the console shows it: its own tester with a question typed in (refocused by
// the Ask phrases, the judge's scores under it) and where the offer starts. No "Learn more" while
// Search or ask has no public docs.
export default function SearchOrAskSection() {
  return (
    <ConsoleFeature
      id="search-or-ask"
      eyebrow="Typed, judged, answered"
      title="Search, or ask"
      lead="Visitors search as they type. When what they type reads like a question, the list already searches what it is about, and they are offered an answer written only from your own records, with the products it used."
      chips={<>
        <KeywordChip icon={<Search_as_you_type/>} className={chipClass} style={{ left: '30%', top: '-18px' }}>Judged while typing</KeywordChip>
        <KeywordChip icon={<Search/>} tone="mid" className={chipClass} style={{ left: '40%', top: '33%' }}>Searches what it is about</KeywordChip>
        <KeywordChip icon={<Quote/>} className={chipClass} style={{ right: '1%', top: '44%' }}>Answers from your records</KeywordChip>
      </>}
      main={{ name: 'search-or-ask', alt: "The console's Search or ask tab: its settings, and the tester beside them, where \"Can you help me find a velvet sofa?\" searches for velvet sofa and offers an answer." }}
      second={{ name: 'search-or-ask-offer', alt: 'When to offer: the score where the quiet invitation and the full offer to answer start, on a scale from lookup to question.' }}
      features={[
        { icon: <Search_or_ask/>, label: 'An answer when it helps' },
        { icon: <Question/>, label: 'Ask phrases, yours to edit' },
        { icon: <Quote/>, label: 'Sources from your records' },
        { icon: <Filter/>, label: 'Descriptions become filters' },
        { icon: <Ai_agent/>, label: 'Follow-up questions' },
        { icon: <Spark/>, label: 'A daily budget you set' },
      ]}
    />
  )
}
